/**
 *
 * Asynchronously loads the component for ShapeRing
 *
 */

import { lazyLoad } from 'utils/loadable';

export const ShapeRing = lazyLoad(
  () => import('./index'),
  module => module.ShapeRing,
);
